import { render, staticRenderFns } from "./PainelItemVisualizacao.vue?vue&type=template&id=4d5bd7fc&scoped=true"
import script from "./PainelItemVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelItemVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./PainelItemVisualizacao.vue?vue&type=style&index=0&id=4d5bd7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5bd7fc",
  null
  
)

export default component.exports